import _ from '../../core/utils'
import SCROLLTO_CONFIG from './config'
import { gsap } from 'gsap'
import { ScrollToPlugin } from 'gsap/ScrollToPlugin.js'
gsap.registerPlugin(ScrollToPlugin)

class ScrolltoClass {
    constructor( el ) {
        this.DOM = {
            el: el,
            offset: el.getAttribute( 'data-offset' ),
            duration: el.getAttribute( 'data-duration' )
        }
        this.duration = SCROLLTO_CONFIG.duration
        this.offset = SCROLLTO_CONFIG.offset
        this.destination = _.select( this.DOM.el.getAttribute( 'href' ) )
        this.init()
    }

    init() {
        this._durationFromDOM()
        this._offsetFromDOM()
        this._listeners()
    }

    _durationFromDOM() {
        this.DOM.duration ? this.duration = parseInt( this.DOM.duration ) : null
    }

    _offsetFromDOM() {
        this.DOM.offset ? this.offset = parseInt( this.DOM.offset ) : null
    }

    _listeners() {
        this.DOM.el.addEventListener( 'click', this._scrollto.bind( this ) )
    }

    _scrollto() {
        event.preventDefault()
        gsap.to( document.documentElement, {
            duration: this.duration, 
            scrollTo: {
                y: this.destination, 
                offsetY: this.offset
            }
        })
    }
}

const SCROLLTOS = []
SCROLLTO_CONFIG.scrolltos.forEach( ( scrollto ) => {  SCROLLTOS.push( new ScrolltoClass( scrollto ) ) })
export default SCROLLTOS
